import '../../CommonStyles.scss';
import KpiCard from '../../components/KpiCard/KpiCard';
import { KpiMeta } from '../../components/KpiCard/KpiMeta';
import { NoData } from '../../components/NoData/NoData';
import { useGetWebinarsSummary } from 'queryHooks/analytics';
import { WebinarsViewsBreakdown } from '../../components/WebinarsViewsBreakdown/WebinarsViewsBreakdown';
import { getLatestDayData } from 'utilities/getLatestDayData';
import { ViewsPerWebinarChartCard } from '../../components/ViewsPerWebinarChart/ViewsPerWebinarChart';
import { ViewsDistributionChartCard } from '../../components/ViewsDistributionChart/ViewsDistributionChart';
import { WebinarsSummaryResponseEntry } from 'types/admin/analytics';

export const WebinarsTab = () => {
  const { data: webinarsSummary, isLoading: webinarsLoading, isError: webinarsError } = useGetWebinarsSummary();

  const latestDayData: WebinarsSummaryResponseEntry[] = getLatestDayData(webinarsSummary || [], 'date');
  const getTotalViewsForLatestDay = () => latestDayData.reduce((sum, v) => sum + v.views, 0);

  const getTopLesson = () => latestDayData.filter((video) => video.kind === 'Lesson').sort((a, b) => b.views - a.views)[0];
  const topLesson = latestDayData.length ? getTopLesson() : null;

  const getTopEvent = () => latestDayData.filter((video) => video.kind === 'Event').sort((a, b) => b.views - a.views)[0];
  const topEvent = latestDayData.length ? getTopEvent() : null;

  return (
    <div className='analytics-tab'>
      {webinarsError || webinarsLoading || !webinarsSummary?.length ? (
        <NoData loading={webinarsLoading} error={webinarsError} noData={!webinarsSummary?.length} />
      ) : (
        <>
          <div className='overview-section'>
            <div className='section-grid metrics'>
              <KpiCard label='Total webinars' sources={['YOUTUBE', 'VIMEO']} value={new Set(webinarsSummary.map((v) => v.videoId)).size} />
              <KpiCard label='Total views' sources={['YOUTUBE', 'VIMEO']} value={getTotalViewsForLatestDay()} />
              {topLesson && (
                <KpiCard label='Top lesson' sources={['YOUTUBE', 'VIMEO']} value={topLesson.title} customClasses='top-webinar-card'>
                  <KpiMeta>{topLesson.views.toLocaleString()} views</KpiMeta>
                </KpiCard>
              )}
              {topEvent && (
                <KpiCard label='Top event' sources={['YOUTUBE', 'VIMEO']} value={topEvent.title} customClasses='top-webinar-card'>
                  <KpiMeta>{topEvent.views.toLocaleString()} views</KpiMeta>
                </KpiCard>
              )}
            </div>
          </div>

          <div className='overview-section'>
            <div className='section-grid trends'>
              <ViewsPerWebinarChartCard />
              <ViewsDistributionChartCard />
            </div>
          </div>

          <div className='overview-section'>
            <WebinarsViewsBreakdown />
          </div>
        </>
      )}
    </div>
  );
};
